import { Component, OnInit } from '@angular/core';
import { PdfMakeWrapper, Img } from 'pdfmake-wrapper';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
// importing definitions
import { Txt, Columns, Table, Ul, Ol } from 'pdfmake-wrapper';
import { AuthService } from 'src/app/services/auth.service';
import { ThrowStmt } from '@angular/compiler';
import { map } from 'rxjs/operators';
import { Observable, of, Subject } from 'rxjs';
import { HttpModule } from '@angular/http';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { ActivatedRoute,Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
//import * as Excel from "exceljs";
import * as Excel from 'exceljs/dist/exceljs.min.js'
import * as fs from 'file-saver';

@Component({
  selector: 'app-assesment',
  templateUrl: './assesment.component.html',
  styleUrls: ['./assesment.component.scss']
})
export class AssesmentComponent implements OnInit {
  constructor(
    public authService: AuthService, 
    private route: ActivatedRoute,
    private _sanitizer: DomSanitizer,
    private router: Router){ 

  }
  ngOnInit() {
    var t= localStorage.getItem("tpo");
    this.persona_id=Number(localStorage.getItem("id_persona"));
    switch (t) {
      case 'P':
       // this.Pgg4();
        break;
      case 'X':
        this.generateExcel();
          break;    
      default:
        break;
    }
  }
  p1;p2;p3;
c1;c2;c3;c4;c5;c6;c7;c8;c9;c10;
c11;c12;c13;c14;c15;c16;
persona_id=0;
checkc(c,n){
if(c==n)return "X"
return "";
}
  async generateExcel() {
    let workbook = new Excel.Workbook();
    let worksheet = workbook.addWorksheet('Car Data');        
    const title = 'Assesment: '+localStorage.getItem("nombre");  
    let titleRow = worksheet.addRow([title]);
    
    titleRow.font = { name: 'Arial', family: 4, size: 16, underline: 'double', bold: true }
    
    worksheet.mergeCells('A1:I2');
    
    let postData = {  
      id_persona:this.persona_id
      
    }
    await this.authService.service("/api/get_evaluacion_dpi",postData)
    .then(
    data => {
      var dat = JSON.stringify(data);
      var res = JSON.parse(dat);                                      
      if(res.length>0){
        this.p1=res[0].p1;this.p2=res[0].p2;this.p3=res[0].p3;         
        this.c1=res[0].c1;this.c2=res[0].c2;this.c3=res[0].c3;this.c4=res[0].c4;this.c5=res[0].c5;this.c6=res[0].c6;this.c7=res[0].c7;this.c8=res[0].c8;this.c9=res[0].c9;this.c10=res[0].c10;   
        this.c11=res[0].c11;this.c12=res[0].c12;this.c13=res[0].c13;this.c14=res[0].c14;this.c15=res[0].c15;this.c16=res[0].c16;   
      }
    },
    error => {
        var de= JSON.stringify(error);
        var di = JSON.parse(de)
        
        
  }); 
    let title1 ;
    title1 =  worksheet.addRow(["Next Role/Succession Opportunities"]);
    title1.fill = {type: 'pattern',pattern: 'solid',fgColor: { argb: 'E0FFFF' }}
    title1.font = { name: 'Arial', family: 4, size: 14, underline: 'double', bold: true }            
    
    title1=worksheet.addRow(["What is their Aspiration?"]);title1.font = { name: 'Arial', family: 4, size: 12, underline: 'double', bold: true }            
    worksheet.addRow([this.p1]);
    title1=worksheet.addRow(["What could they do in 1-3 years,etc.?"]);title1.font = { name: 'Arial', family: 4, size: 12, underline: 'double', bold: true }                    
    worksheet.addRow([this.p2]);

    title1=worksheet.addRow(["Development Opportunities"]); 
    title1.fill = {type: 'pattern',pattern: 'solid',fgColor: { argb: 'E0FFFF' }}
    title1.font = { name: 'Arial', family: 4, size: 14, underline: 'double', bold: true }            
           
    title1=worksheet.addRow(["What are their gaps to get to that next opportunity that we need to address with development?"]);title1.font = { name: 'Arial', family: 4, size: 12, underline: 'double', bold: true }                            
    worksheet.addRow([this.p3]);
    
    title1=worksheet.addRow(["Which solutions/intervention available may help them get there?","Never","Usually","Often","Hardly Ever","Always"]);
    title1.fill = {type: 'pattern',pattern: 'solid',fgColor: { argb: 'cccccc' }, bgColor: { argb: 'FFFFFF' }}
    title1.font = { name: 'Arial', family: 4, size: 12, underline: 'double', bold: true }            

    worksheet.addRow(["360 Assessment An online survey process through which feedback from an employee's subordinates, colleagues, and supervisor(s), as well as a self-evaluation by the employee themselves is gathered.",
                      this.checkc(this.c1,1),this.checkc(this.c1,2),this.checkc(this.c1,3),this.checkc(this.c1,4),this.checkc(this.c1,5)]);
    worksheet.addRow(["Better Up Coach A virtual-live coach to help qualified, high performing leaders build capabilities through scheduled 1:1 coaching session.",
                      this.checkc(this.c2,1),this.checkc(this.c2,2),this.checkc(this.c2,3),this.checkc(this.c2,4),this.checkc(this.c2,5)]);
    worksheet.addRow(["Assessment Identifies role specific strengths and opportunities. Measures behavioral tendencies and cognitive ability and may serve as input into Trinity’s Individual Development Planning Program (IDP).",
                      this.checkc(this.c3,1),this.checkc(this.c3,2),this.checkc(this.c3,3),this.checkc(this.c3,4),this.checkc(this.c3,5)]);
    worksheet.addRow(["Executive Coach To help senior leaders develop skills and strategies to increase their impact and enhance the value they bring to the organization usually in response to taking on a new or more senior role, managing a new initiative and leading change in the organization.",
                      this.checkc(this.c4,1),this.checkc(this.c4,2),this.checkc(this.c4,3),this.checkc(this.c4,4),this.checkc(this.c4,5)]);
    worksheet.addRow(["Crucial Conversations – 2 Day Course A deeper dive into ffocusing on techniques on how to hold such conversations in a positive space when surrounded by highly charged emotions. Their findings are based on 25 years of research with 20,000 people.",
                      this.checkc(this.c5,1),this.checkc(this.c5,2),this.checkc(this.c5,3),this.checkc(this.c5,4),this.checkc(this.c5,5)]);
    worksheet.addRow(["Emotional Intelligence – 2 Day Course Deeper dive into understanding one’s Self-Awareness, Self-Management, Social Awareness, and Relationship Management. Full Assessment, and coaching debrief + action planning comes with the course.",
                      this.checkc(this.c6,1),this.checkc(this.c6,2),this.checkc(this.c6,3),this.checkc(this.c6,4),this.checkc(this.c6,5)]);
    worksheet.addRow(["Customized Curriculum Path Talent Development Team can partner with the employee sponsor to curate a customized learning curriculum with a combination of E-Learning courses, internal or external instructor led courses, articles, videos, books for research and learning, etc.",
                      this.checkc(this.c7,1),this.checkc(this.c7,2),this.checkc(this.c7,3),this.checkc(this.c7,4),this.checkc(this.c7,5)]);
    worksheet.addRow(["Exposure Opportunities Specific opportunities or interventions which will provide the employee the chance to present to, listen, interact, or collaborate with specific parts of the organization to which the employee needs more exposure or experience Prepare specific report/presentation and present to desired exposure group Join a Cross-Functional Team Take the lead/co-lead in a regularly cadenced meeting.",
                      this.checkc(this.c8,1),this.checkc(this.c8,2),this.checkc(this.c8,3),this.checkc(this.c8,4),this.checkc(this.c8,5)]);
    worksheet.addRow(["Job Rotation A well-planned management approach to give an individual a chance to explore his or her own interests and gain experience in different fields or operations. Could be long term or short term project based.",
                      this.checkc(this.c9,1),this.checkc(this.c9,2),this.checkc(this.c9,3),this.checkc(this.c9,4),this.checkc(this.c9,5)]);
    worksheet.addRow(["Job Specific Certification or Training Externally regulated or audited training course or assessment needed for the employee to advance or accomplish their role.",
                      this.checkc(this.c10,1),this.checkc(this.c10,2),this.checkc(this.c10,3),this.checkc(this.c10,4),this.checkc(this.c10,5)]);
    worksheet.addRow(["Management 101 Introduction to a People Leader’s role and responsibilities to support the full life cycle of their direct report. Topics including selection and interviewing, performance management, benefits, promotion and termination.",
                      this.checkc(this.c11,1),this.checkc(this.c11,2),this.checkc(this.c11,3),this.checkc(this.c11,4),this.checkc(this.c11,5)]);
    worksheet.addRow(["Leadership Programs Leadership Programs designed to accelerate your development as a leader.",
                      this.checkc(this.c12,1),this.checkc(this.c12,2),this.checkc(this.c12,3),this.checkc(this.c12,4),this.checkc(this.c12,5)]);
    worksheet.addRow(["Mentor Assignment A mentor is assigned to help that person develop a broader skill set.  The mentor may help with exploring careers, setting goals, developing contacts, and identifying resources.",
                      this.checkc(this.c13,1),this.checkc(this.c13,2),this.checkc(this.c13,3),this.checkc(this.c13,4),this.checkc(this.c13,5)]);
    worksheet.addRow(["Presentation Skills Understand the fundamentals of effective, successful presentations, plan and prepare powerful presentations that engage the audience, eliminate speaker anxiety and nervousness, polish and learn delivery techniques to present information like a professional, use visual aids effectively, and skillfully handle difficult presentation situations.",
                      this.checkc(this.c14,1),this.checkc(this.c14,2),this.checkc(this.c14,3),this.checkc(this.c14,4),this.checkc(this.c14,5)]);
    worksheet.addRow(["Situational Leadership II A model that teaches managers how to set clear goals, diagnose development levels, and determine the correct leadership style to bring out the best in people. ",
                      this.checkc(this.c15,1),this.checkc(this.c15,2),this.checkc(this.c15,3),this.checkc(this.c15,4),this.checkc(this.c15,5)]);
    worksheet.addRow(["Stretch Assignments High impact projects, initiatives, or potentially roles which stretch an employee beyond their experience and demonstrated capabilities, meant to develop the employee. A “learn by doing” approach.",
                      this.checkc(this.c16,1),this.checkc(this.c16,2),this.checkc(this.c16,3),this.checkc(this.c16,4),this.checkc(this.c16,5)]);
    let headerRow = worksheet.addRow("");        
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'e8c82f' },
        bgColor: { argb: 'FF0000FF' }
      }
      cell.font={ color:{argb:"FFFFFF"} ,size: 12};
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    });    
    let footerRow = worksheet.addRow(['Report V1.']);
    footerRow.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFCCFFE5' }
    };
    worksheet.getColumn(1).width = 110; 
    worksheet.getColumn(2).width = 14;
    worksheet.getColumn(3).width = 14;
    worksheet.getColumn(4).width = 14;
    worksheet.getColumn(5).width = 14;
    worksheet.getColumn(6).width = 14;
    worksheet.getColumn(1).alignment={horizontal:"justify",wrapText: true} 
    worksheet.getColumn(2).alignment={horizontal:"center",wrapText: true} 
    worksheet.getColumn(3).alignment={horizontal:"center",wrapText: true} 
    worksheet.getColumn(4).alignment={horizontal:"center",wrapText: true} 
    worksheet.getColumn(5).alignment={horizontal:"center",wrapText: true} 
    worksheet.getColumn(6).alignment={horizontal:"center",wrapText: true} 
    footerRow.getCell(1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    worksheet.mergeCells(`A${footerRow.number}:F${footerRow.number}`);
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'CarData.xlsx');
    });  
    setTimeout(function(){
      window.close();
    },4000);
  }
}

